// Manejar clics en el botón del header para abrir el pop-up
if (typeof window.FoxTheme !== 'undefined' && window.FoxTheme.DOMready) {
  window.FoxTheme.DOMready(() => {
    bindHeaderLocationPopupButtons();
    
    if (window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        () => {
          setTimeout(() => {
            const popup = document.querySelector('location-popup');
            if (popup?.updateHeaderButtonText) {
              popup.updateHeaderButtonText();
            }
          }, 100);
        }
      );
    }
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    bindHeaderLocationPopupButtons();
  });
}

if (!customElements.get('location-popup')) {
  customElements.define(
    'location-popup',
    class LocationPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }
      
      constructor() {
        super();
      }
      
      show(activeElement = null, animate = true) {
        const cartDrawer = document.getElementById('CartDrawer');
        if (cartDrawer) {
          if (typeof cartDrawer.hide === 'function') {
            cartDrawer.hide();
          } else if (typeof cartDrawer.close === 'function') {
            cartDrawer.close();
          } else {
            const closeBtn = cartDrawer.querySelector('.drawer__close-btn[aria-controls="CartDrawer"]') || cartDrawer.querySelector('.drawer__close-btn');
            if (closeBtn) closeBtn.click();
          }
        }
        return super.show(activeElement, animate);
      }
      
      get requiresBodyAppended() {
        return false;
      }
      
      async connectedCallback() {
        super.connectedCallback();
        
        this.customerPostalCode = this.dataset.customerPostalCode || '';
        this.changedPostalCode = false;
        this.currentPostalCode = null;
        this.isPickupMode = this.dataset.pickupMode === 'true';
        this.storeCode = this.dataset.storeCode || '';
        
        // Referencias a los elementos
        this.postalCodeInput = this.querySelector('#postal-code-input');
        this.storeSelect = this.querySelector('#store-select');
        this.deliveryEnterBtn = this.querySelector('#delivery-enter-btn');
        this.mainEnterBtn = this.querySelector('#main-enter-btn');
        
        if (this.isPickupMode && this.storeCode) {
          if (this.storeSelect) {
            this.storeSelect.value = this.storeCode;
          }
          if (this.mainEnterBtn) {
            this.mainEnterBtn.disabled = false;
          }
        }
        
        this._mobileQuery = window.matchMedia('(max-width: 767px)');
        this._mobileQuery.addEventListener('change', () => {
          this.updateHeaderButtonText();
        });
        
        // Event listeners
        if (this.deliveryEnterBtn) {
          this.deliveryEnterBtn.addEventListener('click', () => this.handleDeliveryEnter());
        }
        if (this.mainEnterBtn) {
          this.mainEnterBtn.addEventListener('click', () => this.handleMainEnter());
        }
        
        if (this.postalCodeInput) {
          this.postalCodeInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              this.handleDeliveryEnter();
            }
          });
        }
        
        // Obtener CP guardado: primero del header (server-rendered), luego del carrito.
        // Se llama fetchDeliveryTimeSlots para que CP en header y ventanas de entrega
        // aparezcan al mismo tiempo (evita que el CP se pinte antes que las ventanas).
        const headerButton = document.querySelector('.header__location-button[data-postal-code]');
        let initialPostalCode = headerButton?.getAttribute('data-postal-code') || await this.getCartPostalCode();
        this.currentPostalCode = initialPostalCode;
        
        if (!initialPostalCode) {
          const localCp = localStorage.getItem('wim_postal_code');
          const localValid = localStorage.getItem('wim_postal_code_valid');
          if (localCp && localValid === 'true') {
            try {
              await this.savePostalCodeToCart(localCp, true);
              window.location.reload();
              return;
            } catch (e) {
              console.error('Error restoring postal code from localStorage:', e);
            }
          }
        }
        
        if (initialPostalCode) {
          this.fetchDeliveryTimeSlots(initialPostalCode);
        }
        
        this.updateHeaderButtonText();
        
        if (this.storeSelect && this.postalCodeInput && this.deliveryEnterBtn) {
          this.storeSelect.addEventListener('change', async () => {
            const selectedSc = this.storeSelect.value;
            if (!selectedSc) return;
            
            this.isPickupMode = true;
            if (this.mainEnterBtn) this.mainEnterBtn.disabled = false;
            
            const section3 = this.querySelector('.location-popup__section.section_3');
            if (section3) section3.style.display = '';
            const prevDivider3 = section3 ? section3.previousElementSibling : null;
            if (prevDivider3 && prevDivider3.classList.contains('location-popup__divider')) {
              prevDivider3.style.display = '';
            }
            
            const shippingOptionsContainer = this.querySelector('.location-popup-shippingOptions');
            if (shippingOptionsContainer) shippingOptionsContainer.style.display = '';
            
            const errorMsg = this.querySelector('.location-popup__section-errors');
            if (errorMsg) errorMsg.classList.add('hidden');
            const successMsg = this.querySelector('.location-popup__section-success');
            if (successMsg) successMsg.classList.add('hidden');
            
            this.querySelectorAll('.shipping-slot.selected').forEach(el => el.classList.remove('selected'));
            
            if (window.FoxTheme && window.FoxTheme.cpStoreMapping) {
              const store = window.FoxTheme.cpStoreMapping.find(s => s.sc === selectedSc);
              if (store && store.pcs && store.pcs.length > 0) {
                this.postalCodeInput.value = '';
                this.lastSearchedCp = store.pcs[0];
                this.lastSearchedCpValid = true;
                
                await this.fetchDeliveryTimeSlots(store.pcs[0], true);
              }
            }
          });
          
          this.postalCodeInput.addEventListener('input', () => {
            const errorMsg = this.querySelector('.location-popup__section-errors');
            if (errorMsg) errorMsg.classList.add('hidden');
            const successMsg = this.querySelector('.location-popup__section-success');
            if (successMsg) successMsg.classList.add('hidden');
            
            const val = this.postalCodeInput.value.trim();
            if (val === '') {
              this.isPickupMode = false;
              this.lastSearchedCp = '';
              this.lastSearchedCpValid = false;
              
              const section2 = this.querySelector('.location-popup__section.section_2');
              if (section2) {
                section2.style.display = '';
                const prevDivider = section2.previousElementSibling;
                if (prevDivider && prevDivider.classList.contains('location-popup__divider')) {
                  prevDivider.style.display = '';
                }
              }
              
              const section3 = this.querySelector('.location-popup__section.section_3');
              if (section3) section3.style.display = 'none';
              const prevDivider3 = section3 ? section3.previousElementSibling : null;
              if (prevDivider3 && prevDivider3.classList.contains('location-popup__divider')) {
                prevDivider3.style.display = 'none';
              }
              
              const shippingOptionsContainer = this.querySelector('.location-popup-shippingOptions');
              if (shippingOptionsContainer) shippingOptionsContainer.style.display = 'none';
              
              if (this.storeSelect) {
                this.storeSelect.selectedIndex = 0;
              }
              
              if (this.mainEnterBtn) {
                this.mainEnterBtn.disabled = true;
              }
              
              this.querySelectorAll('.shipping-slot.selected').forEach(el => el.classList.remove('selected'));
            } else {
              // Si el usuario escribe algo en el CP, cancelamos el modo recogida y reseteamos la selección de tienda
              this.isPickupMode = false;
              if (this.storeSelect) {
                this.storeSelect.selectedIndex = 0;
              }
            }
          });
        }
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        
        async function fetchCartChangeWithRetry(item, options = {}) {
          const {
            maxRetries = 5,      // número máximo de reintentos para 409
            initialDelay = 150,  // delay base para backoff
          } = options;
          
          for (let attempt = 0; attempt <= maxRetries; attempt++) {
            try {
              const response = await fetch(FoxTheme.routes.cart_change_url, {
                ...FoxTheme.utils.fetchConfig(),
                body: JSON.stringify(item),
              });
              
              if (response.ok) {
                return response;
              }
              
              // Si no es 409, no tiene sentido reintentar aquí
              if (response.status !== 409) {
                const text = await response.text().catch(() => "");
                throw new Error(`HTTP ${response.status} ${text}`);
              }
              
              // Si es 409 pero ya agotamos intentos
              if (attempt === maxRetries) {
                throw new Error(`HTTP 409 conflict after ${maxRetries + 1} attempts`);
              }
              
              // Backoff exponencial + jitter leve
              const jitter = Math.floor(Math.random() * 100); // 0-99ms
              const waitMs = initialDelay * 2 ** attempt + jitter;
              console.warn(`[cart_change] 409 conflict. Retry ${attempt + 1}/${maxRetries} in ${waitMs}ms`, item );
              await sleep(waitMs);
            } catch (error) {
              // Error de red (fetch falla) -> también reintentar hasta maxRetries
              if (attempt === maxRetries) {
                throw error;
              }
              
              const waitMs = initialDelay * 2 ** attempt;
              console.warn( `[cart_change] Network error. Retry ${attempt + 1}/${maxRetries} in ${waitMs}ms`, error );
              await sleep(waitMs);
            }
          }
        }
        const getMatchChecks = (item, campaign) => {
          const properties = item.properties || {};
          return {
            variantId: { campaign: campaign.variantId, item: item.variant_id.toString(), ok: campaign.variantId === item.variant_id.toString() },
            existWeight: { campaign: campaign.existWeight, item: !!properties['peso'], ok: campaign.existWeight === (!!properties['peso']) },
            cuttingType: { campaign: campaign.cuttingType, item: properties['preparación'] || '', ok: campaign.cuttingType === (properties['preparación'] || '') },
          };
        };
        
        const getUpdateChecks = (item, campaign) => {
          const properties = item.properties || {};
          return {
            _id_campaign_pp1: { campaign: campaign.idCampaign1, item: properties['_id_campaign_pp1'], differs: campaign.idCampaign1 !== properties['_id_campaign_pp1'] },
            _id_campaign_pp2: { campaign: campaign.idCampaign2, item: properties['_id_campaign_pp2'], differs: campaign.idCampaign2 !== properties['_id_campaign_pp2'] },
            _id_campaign_pp3: { campaign: campaign.idCampaign3, item: properties['_id_campaign_pp3'], differs: campaign.idCampaign3 !== properties['_id_campaign_pp3'] },
            _id_nw: { campaign: campaign.idNw, item: properties['_id_nw'], differs: campaign.idNw !== properties['_id_nw'] },
          };
        };
        
        const findItemForCampaign = (items, campaign, index, total) => {
          // console.groupCollapsed(`[cart_campaigns] Campaña ${index + 1}/${total} - variant ${campaign.variantId}`);
          // console.log('Datos de la campaña (DOM):', { ...campaign });
          // console.log('Items actuales del carrito:', items.map(i => ({ key: i.key, variant_id: i.variant_id, quantity: i.quantity, properties: i.properties })));
          
          let found = null;
          for (const item of items) {
            const matchChecks = getMatchChecks(item, campaign);
            const isMatch = Object.values(matchChecks).every(c => c.ok);
            // console.log(`Item ${item.key} -> match: ${isMatch}`);
            // console.table(matchChecks);
            if (!isMatch) continue;
            
            const updateChecks = getUpdateChecks(item, campaign);
            const needsUpdate = Object.values(updateChecks).some(c => c.differs);
            // console.log(`Item ${item.key} -> necesita actualizar: ${needsUpdate}`);
            // console.table(updateChecks);
            if (needsUpdate) {
              found = item;
              break;
            }
          }
          
          // console.log(found ? `Resultado: se actualizará el item ${found.key}` : 'Resultado: no hay item que actualizar para esta campaña');
          // console.groupEnd();
          return found;
        };
        
        const buildCampaignPayload = (item, campaign) => ({
          id: item.key,
          quantity: item.quantity,
          properties: {
            ...item.properties,
            '_id_campaign_pp1': campaign.idCampaign1,
            '_id_campaign_pp2': campaign.idCampaign2,
            '_id_campaign_pp3': campaign.idCampaign3,
            '_id_nw': campaign.idNw,
          },
        });
        
        // Recorre las campañas una a una. Cada cart/change devuelve el carrito actualizado
        // (con nuevos keys), por lo que el siguiente item se busca sobre esos items frescos.
        async function updateCartItemsSafely(cartItemCampaigns, initialItems) {
          let currentItems = Array.isArray(initialItems) ? initialItems : [];
          let success = 0;
          let failed = 0;
          const errors = [];
          
          // console.info('[cart_campaigns] Inicio. Campañas recopiladas del DOM:', cartItemCampaigns.length);
          // console.table(cartItemCampaigns);
          
          for (const [index, campaign] of cartItemCampaigns.entries()) {
            const item = findItemForCampaign(currentItems, campaign, index, cartItemCampaigns.length);
            if (!item) continue;
            
            const payload = buildCampaignPayload(item, campaign);
            // console.log(`[cart_campaigns] Payload enviado a cart/change (campaña ${index + 1}):`, payload);
            try {
              const response = await fetchCartChangeWithRetry(payload, {
                maxRetries: 5,
                initialDelay: 150,
              });
              const updatedCart = await response.json();
              if (Array.isArray(updatedCart?.items)) {
                const previousKeys = currentItems.map(i => i.key);
                currentItems = updatedCart.items;
                // console.log('[cart_campaigns] Keys antes del change:', previousKeys);
                // console.log('[cart_campaigns] Keys después del change:', currentItems.map(i => i.key));
                const updatedItem = currentItems.find(i => i.variant_id === item.variant_id && Object.values(getMatchChecks(i, campaign)).every(c => c.ok));
                // console.log('[cart_campaigns] Properties del item tras el change:', updatedItem ? updatedItem.properties : 'no encontrado');
              } else {
                console.warn('[cart_campaigns] La respuesta de cart/change no trae items:', updatedCart);
              }
              
              campaign.apply = true;
              success++;
              // console.info( `[cart_change] Updated campaign ${index + 1}/${cartItemCampaigns.length}`, payload.id );
            } catch (error) {
              failed++;
              errors.push({ index, item: payload, error: String(error) });
              // console.error( `[cart_change] Failed campaign ${index + 1}/${cartItemCampaigns.length}`, payload, error );
              // Si falló, refrescamos el carrito para no usar keys obsoletos en el siguiente item
              try {
                const r = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
                const freshCart = await r.json();
                if (Array.isArray(freshCart?.items)) currentItems = freshCart.items;
                // console.log('[cart_campaigns] Carrito refrescado tras error. Keys:', currentItems.map(i => i.key));
              } catch (refreshError) {
                // console.error('[cart_campaigns] No se pudo refrescar el carrito tras error:', refreshError);
              }
            }
            
            // Pausa fija entre items para reducir probabilidad de conflicto
            await sleep(120);
          }
          
          // console.info("[cart_change] Done", { success, failed });
          // console.table(cartItemCampaigns.map(c => ({ variantId: c.variantId, cuttingType: c.cuttingType, existWeight: c.existWeight, apply: c.apply })));
          return { success, failed, errors };
        }
        try {
          
          FoxTheme.utils.updateDate().then(() => {
            fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' }).then(r => r.json()).then(cart => {
              const postalCode = cart.attributes?.postal_code || '';
              const storeCode = cart.attributes?.store_code || '';
              
              if (storeCode && !postalCode) {
                this.isPickupMode = true;
                if (this.storeSelect) {
                  this.storeSelect.value = storeCode;
                }
                if (this.mainEnterBtn) {
                  this.mainEnterBtn.disabled = false;
                }
                
                const section3 = this.querySelector('.location-popup__section.section_3');
                if (section3) section3.style.display = 'none';
                const prevDivider3 = section3 ? section3.previousElementSibling : null;
                if (prevDivider3 && prevDivider3.classList.contains('location-popup__divider')) {
                  prevDivider3.style.display = 'none';
                }
                const shippingOptionsContainer = this.querySelector('.location-popup-shippingOptions');
                if (shippingOptionsContainer) shippingOptionsContainer.style.display = 'none';
              }
              if(storeCode){
                
                const cartItemCampaigns = Array.from(document.querySelectorAll('cart-items ul li.cart-item')).reduce((prevItem, currentItem) => {
                  if( currentItem !== null){
                    prevItem.push({
                      variantId: currentItem.dataset.variantId,
                      existWeight: currentItem.dataset.weight == 'true',
                      cuttingType: currentItem.dataset.cuttingType,
                      idCampaign1: currentItem.dataset.idCampaignPp1,
                      idCampaign2: currentItem.dataset.idCampaignPp2,
                      idCampaign3: currentItem.dataset.idCampaignPp3,
                      idNw: currentItem.dataset.idNw,
                      apply: false
                    });
                  }
                  return prevItem;
                }, []);
                if(cartItemCampaigns.length > 0){
                  updateCartItemsSafely(cartItemCampaigns, cart.items);
                }
              }
            });
          });
        } catch (e) {
          console.error(e);
        }
      }
      
      async getCartPostalCode() {
        try {
          return await FoxTheme.utils.updateDate().then(async () => {
            const response = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
            const cart = await response.json();
            
            if (cart.attributes && (cart.attributes['postal_code'] )) {
              let exist_sc = FoxTheme.cpStoreMapping.find(store => store.sc === cart.attributes['store_code']);
              let valid_pc = exist_sc ? exist_sc.pcs.includes(cart.attributes['postal_code']) : false;
              return exist_sc && valid_pc ? cart.attributes['postal_code'] : null;
            }
            return null;
          }).catch(() => null);
        } catch (error) {
          return null;
        }
      }
      
      async handleDeliveryEnter() {
        const postalCode = this.postalCodeInput?.value.trim();
        
        this.changedPostalCode = postalCode !== this.currentPostalCode;
        
        if (!postalCode) {
          this.postalCodeInput?.focus();
          return;
        }
        
        // Reset pickup mode and store select when searching a CP
        this.isPickupMode = false;
        if (this.storeSelect) {
          this.storeSelect.selectedIndex = 0;
        }
        
        // Mostrar loading
        if (this.deliveryEnterBtn) {
          this.deliveryEnterBtn.classList.add('btn--loading');
          this.deliveryEnterBtn.disabled = true;
        }
        
        try {
          await this.fetchDeliveryTimeSlots(postalCode, true);
          
          if (this.deliveryEnterBtn) {
            this.deliveryEnterBtn.classList.remove('btn--loading');
            this.deliveryEnterBtn.disabled = false;
          }
        } catch (error) {
          // Remover loading en caso de error
          if (this.deliveryEnterBtn) {
            this.deliveryEnterBtn.classList.remove('btn--loading');
            this.deliveryEnterBtn.disabled = false;
          }
          
        }
      }
      
      async handleMainEnter() {
        if (!this.mainEnterBtn) return;
        
        this.mainEnterBtn.classList.add('btn--loading');
        this.mainEnterBtn.disabled = true;
        
        try {
          const currentInput = this.postalCodeInput?.value.trim();
          
          if (currentInput && currentInput !== this.lastSearchedCp && !this.isPickupMode) {
            await this.fetchDeliveryTimeSlots(currentInput, true);
          }
          
          if (!this.isPickupMode && currentInput) {
            this.changedPostalCode = (currentInput !== this.currentPostalCode);
          }
          
          if (this.lastSearchedCp || this.isPickupMode) {
            await this.savePostalCodeToCart(this.lastSearchedCp || '', this.lastSearchedCpValid, window.location.href.indexOf('/cart') < 0);
          }
          
          const cartPostalCode = await this.getCartPostalCode();
          if (cartPostalCode || this.lastSearchedCp) {
            // Solo redirigir si el usuario realizó una búsqueda activa en esta sesión
            if(this.getAttribute('data-wim-checkout') === 'true' && !this.changedPostalCode && document.querySelector('.shipping-slot.selected')) {
              const selectedSlot = document.querySelector('.shipping-slot.selected');
              if (selectedSlot) {
                const start = selectedSlot.getAttribute('data-start');
                const end = selectedSlot.getAttribute('data-end');
                const existCart = document.querySelector('.wim-cart-drawer') || document.querySelector('.wim-main-cart');
                if (existCart) {
                  existCart.setAttribute('data-shipping-option', JSON.stringify(JSON.stringify({start, end})));
                }
              }
              this.hide();
              setTimeout(() => {
                const checkoutBtn = document.querySelector('#wim-validate-checkout');
                if (checkoutBtn) {
                  checkoutBtn.click();
                } else {
                  document.querySelector('#wim-cart-form button[type="submit"]')?.click();
                }
              }, 100);
            }
            else{
              if (this.lastSearchedCp) {
                // Verificar si hay que mostrar el popup de pescado fresco tras el reload
                const selectedSlot = document.querySelector('.shipping-slot.selected');
                let slotIsMonday = false;
                if (selectedSlot) {
                  const slotStart = selectedSlot.dataset.start;
                  if (slotStart) {
                    const slotDateObj = new Date(slotStart.split('T')[0] + 'T00:00:01');
                    slotIsMonday = slotDateObj.getDay() === 1;
                  }
                } else {
                  // Fallback: check the preserved shipping option attribute in the cart drawer
                  const existCart = document.querySelector('.wim-cart-drawer') || document.querySelector('.wim-main-cart');
                  const shippingOption = existCart?.getAttribute('data-shipping-option');
                  if (shippingOption) {
                    try {
                      let parsedOpt = JSON.parse(shippingOption);
                      if (typeof parsedOpt === 'string') parsedOpt = JSON.parse(parsedOpt);
                      if (parsedOpt?.start) {
                        const slotDateObj = new Date(parsedOpt.start.split('T')[0] + 'T00:00:01');
                        slotIsMonday = slotDateObj.getDay() === 1;
                      }
                    } catch (_) {}
                  }
                }
                const isPrehome = window.location.pathname.includes('prehome') || window.location.pathname === '/';
                if (isPrehome) {
                  window.location.href = '/pages/home';
                } else {
                  window.location.reload();
                }
              } else {
                // CP ya existía en carrito pero no hubo búsqueda nueva: solo cerrar el popup
                this.hide();
              }
            }
            this.currentPostalCode = null;
            this.changedPostalCode = false;
            this.setAttribute('data-wim-checkout', 'false');
            return;
          }
          
          this.mainEnterBtn.disabled = false;
          this.mainEnterBtn.classList.remove('btn--loading');
        } catch (error) {
          this.mainEnterBtn.disabled = false;
          this.mainEnterBtn.classList.remove('btn--loading');
        }
      }
      
      
      resolveSCForCP(cp) {
        let result = '';
        for (let item of FoxTheme.cpStoreMapping) {
          if (item.pcs && item.pcs.includes(cp)) {
            result = item.sc;
            break;
          }
        }
        return result;
      }
      
      async savePostalCodeToCart(postalCode, isValid = false, isCartDrawer = true) {
        const sc = isValid ? (this.isPickupMode && this.storeSelect ? this.storeSelect.value : this.resolveSCForCP(String(postalCode).trim())) : '';
        
        let storeNameAttr = '';
        if (isValid && this.isPickupMode && this.storeSelect) {
          const selectedOption = this.storeSelect.options[this.storeSelect.selectedIndex];
          if (selectedOption && selectedOption.value) {
            storeNameAttr = selectedOption.textContent.trim();
          }
        }
        
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        
        let payloadAttributes = {
          postal_code: postalCode,
          postal_code_valid: isValid ? 'true' : 'false',
          store_code: sc,
          store_name: storeNameAttr,
          pickup_mode: this.isPickupMode ? 'true' : 'false',
          now: FoxTheme.utils.getDate()
        };
        
        // Preserve ShippingOptionSelect to avoid Shopify overwriting all attributes
        try {
          const cartRes = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
          const currentCart = await cartRes.json();
          if (currentCart && currentCart.attributes && currentCart.attributes.ShippingOptionSelect) {
            payloadAttributes['ShippingOptionSelect'] = currentCart.attributes.ShippingOptionSelect;
          }
        } catch(e) {
          console.error("Failed to fetch current attributes", e);
        }
        
        // No borrar la selección de franjas horarias al estar en recogida en tienda (pickup)
        
        const response = await fetch(FoxTheme.routes.cart_update_url, {
          ...FoxTheme.utils.fetchConfig(),
          body: JSON.stringify({
            attributes: payloadAttributes,
            sections: sectionsToBundle,
            sections_url: window.location.pathname
          })
        });
        
        if (!response.ok) {
          throw new Error('Error al actualizar el carrito');
        }
        
        const cartJson = await response.json();
        this.currentPostalCode = postalCode;
        
        if (isValid) {
          localStorage.setItem('wim_postal_code', postalCode);
          localStorage.setItem('wim_postal_code_valid', 'true');
          if (sc) {
            localStorage.setItem('wim_store_code', sc);
          }
        } else {
          localStorage.removeItem('wim_postal_code');
          localStorage.removeItem('wim_postal_code_valid');
          localStorage.removeItem('wim_store_code');
        }
        
        document.dispatchEvent(new CustomEvent('wim:postal-code:updated', {
          bubbles: true,
          detail: { postalCode: postalCode, storeCode: sc }
        }));
        document.dispatchEvent(new CustomEvent('wim:cp-updated', {
          bubbles: true,
          detail: { postalCode: postalCode, storeCode: sc }
        }));
        if (isCartDrawer) {
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            { cart: cartJson }
          );
        }
      }
      
      
      updateHeaderButtonText(postalCode = null) {
        const headerButtons = document.querySelectorAll('[data-location-popup-trigger]');
        
        headerButtons.forEach(button => {
          const textElement = button.querySelector('.header__location-button-text');
          
          if (postalCode) {
            button.setAttribute('data-has-postal-code', 'true');
            button.setAttribute('data-postal-code', postalCode);
            button.setAttribute('aria-label', `${window.webimpacto?.translates?.popup?.send_to} ${postalCode}`);
            button.classList.add('target');
            if (textElement) {
              const isMobile = (this._mobileQuery || window.matchMedia('(max-width: 767px)')).matches;
              textElement.textContent = isMobile ? postalCode : `${window.webimpacto?.translates?.popup?.send_to} ${postalCode}`;
            }
          } else {
            FoxTheme.utils.updateDate().then(() => {
              fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' }).then(r => r.json()).then(cart => {
                let postalCodeToUse = cart.attributes?.postal_code || '';
                const isPickup = cart.attributes?.pickup_mode === 'true';
                const storeCode = cart.attributes?.store_code || '';
                let storeName = '';
                
                if (isPickup && storeCode) {
                  const storeSelect = document.querySelector('#store-select');
                  if (storeSelect) {
                    const option = storeSelect.querySelector(`option[value="${storeCode}"]`);
                    if (option && option.value) {
                      storeName = option.textContent.trim();
                    }
                  }
                }
                
                if (!postalCodeToUse && this.customerPostalCode) {
                  postalCodeToUse = this.customerPostalCode;
                }
                
                if (postalCodeToUse || storeName) {
                  const displayText = (isPickup && storeName) ? storeName : postalCodeToUse;
                  button.setAttribute('data-has-postal-code', 'true');
                  button.setAttribute('data-postal-code', postalCodeToUse);
                  
                  const prefix = isPickup ? (window.webimpacto?.translates?.popup?.pickup_in || 'Retiro en') : (window.webimpacto?.translates?.popup?.send_to || 'Enviar a');
                  button.setAttribute('aria-label', `${prefix} ${displayText}`);
                  
                  if (textElement) {
                    const isMobile = (this._mobileQuery || window.matchMedia('(max-width: 767px)')).matches;
                    if (isMobile) {
                      textElement.textContent = displayText;
                    } else {
                      textElement.textContent = `${prefix} ${displayText}`;
                    }
                  }
                } else {
                  button.removeAttribute('data-has-postal-code');
                  button.removeAttribute('data-postal-code');
                  button.setAttribute('aria-label', `${window.webimpacto?.translates?.popup?.enter_postal_code} `);
                  if (textElement) {
                    textElement.textContent = `${window.webimpacto?.translates?.popup?.enter_cp} `;
                  }
                }
              })
              .catch(e => console.error('Error actualizando texto del botón:', e));
            }).catch(e => {console.error('Error obteniendo fecha para actualizar texto del botón:', e)});
          }
        });
      }
      
      async fetchDeliveryTimeSlots(pc, isManual = false) {
        const container = this.querySelector('.location-popup__content');
        if (container) container.classList.add('loading');
        
        const headerBtns = document.querySelectorAll('.header__location-button[data-location-popup-trigger]');
        headerBtns.forEach(btn => {
          btn.classList.add('btn--loading');
          btn.disabled = true;
        });
        
        try {
          
          if (this.storeSelect && !this.storeSelect.value) {
            this.isPickupMode = false;
          }
          
          const section2 = this.querySelector('.location-popup__section.section_2');
          if (section2) {
            section2.style.display = '';
            const prevDivider = section2.previousElementSibling;
            if (prevDivider && prevDivider.classList.contains('location-popup__divider')) {
              prevDivider.style.display = '';
            }
          }
          
          const section3 = this.querySelector('.location-popup__section.section_3');
          if (section3) section3.style.display = '';
          const prevDivider3 = section3 ? section3.previousElementSibling : null;
          if (prevDivider3 && prevDivider3.classList.contains('location-popup__divider')) {
            prevDivider3.style.display = '';
          }
          
          const shippingOptionsContainer = this.querySelector('.location-popup-shippingOptions');
          if (shippingOptionsContainer) shippingOptionsContainer.style.display = '';
          
          const response = await fetch('https://public.delivery.janis.in/api/simulate', {
            method: 'POST',
            headers: {
              'janis-client': 'ladespensa',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              slaName: ["Delivery"],
              dropoff: {
                postalCode: pc
              }
            })
          });
          
          if (!response.ok) {
            throw new Error(`Janis API error: ${response.status}`);
          }
          
          const data = await response.json();
          
          let windows = data?.shippingOptions?.[0]?.windows || []; 
          
          // Formatear las horas UTC a hora local de Madrid (replicando el WMI)
          const formatMadrid = (dateStr) => {
            const date = new Date(dateStr);
            const options = { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
            const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date);
            const p = {};
            parts.forEach(part => p[part.type] = part.value);
            
            const madridTimeMs = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
            const diffMinutes = Math.round((madridTimeMs - date.getTime()) / 60000);
            const sign = diffMinutes >= 0 ? '+' : '-';
            const hours = String(Math.floor(Math.abs(diffMinutes) / 60)).padStart(2, '0');
            const mins = String(Math.abs(diffMinutes) % 60).padStart(2, '0');
            
            return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}${sign}${hours}:${mins}`;
          };
          
          windows = windows.map(win => ({
            ...win,
            start: formatMadrid(win.start),
            end: formatMadrid(win.end)
          }));
          
          this.renderShippingOptions(windows);
          
          const errorMessage = this.querySelector('.location-popup__section-errors');
          const successMessage = this.querySelector('.location-popup__section-success');
          const hasWindows = windows.length > 0;
          if (errorMessage) errorMessage.classList.toggle('hidden', hasWindows);
          if (successMessage) successMessage.classList.toggle('hidden', !hasWindows);
          
          if (!hasWindows && section2) {
            section2.style.display = '';
            const prevDivider = section2.previousElementSibling;
            if (prevDivider && prevDivider.classList.contains('location-popup__divider')) {
              prevDivider.style.display = '';
            }
          }
          
          this.mainEnterBtn.disabled = false;
          if (this.isPickupMode) {
            const storeCode = this.resolveSCForCP(pc);
            if (storeCode && this.storeSelect) {
              this.storeSelect.value = storeCode;
            }
          } else {
            if (this.storeSelect) {
              this.storeSelect.selectedIndex = 0;
            }
          }
          
          this.applySelectedShippingSlot();
          this.lastSearchedCp = pc;
          this.lastSearchedCpValid = hasWindows;
          
          const isPrehome = window.location.pathname.includes('prehome') || (isManual && window.location.pathname === '/');
          if (isPrehome && hasWindows) {
            await this.savePostalCodeToCart(pc, true);
          }
          return data;
        } catch (error) {
          return null;
        } finally {
          if (container) container.classList.remove('loading');
          const headerBtns = document.querySelectorAll('.header__location-button[data-location-popup-trigger]');
          headerBtns.forEach(btn => {
            btn.classList.remove('btn--loading');
            btn.disabled = false;
          });
        }
      }
      
      groupWindowsByDay(windows) {
        return windows.reduce((acc, window) => {
          const date = window.start.split('T')[0]; // YYYY-MM-DD
          
          if (!acc[date]) {
            acc[date] = [];
          }
          
          acc[date].push(window);
          return acc;
        }, {});
      }
      
      renderShippingOptions(windows) {
        const container = this.querySelector('.location-popup-shippingOptions');
        if (!container) return;
        
        container.innerHTML = '';
        
        const now = new Date();
        const localYear = now.getFullYear();
        const localMonth = String(now.getMonth() + 1).padStart(2, '0');
        const localDay = String(now.getDate()).padStart(2, '0');
        const localTodayStr = `${localYear}-${localMonth}-${localDay}`;
        const isAfterCutoff = now.getHours() >= 14;
        
        const hasTodayWindows = windows.some(win => win.start.split('T')[0] === localTodayStr);
        
        if (windows.length > 0) {
          if (hasTodayWindows && isAfterCutoff) {
            const cutoffWarning = document.createElement('div');
            cutoffWarning.className = 'location-popup-shippingOptions-cutoff-warning';
            cutoffWarning.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor"/>
              </svg>
              <span>${window.webimpacto?.translates?.popup?.same_day_cutoff_warning || 'El límite para entrega el mismo día es antes de las 14:00. Las franjas de hoy se muestran bloqueadas.'}</span>
            `;
            container.appendChild(cutoffWarning);
          }
          
          const extraInfo = document.createElement('div');
          extraInfo.className = 'location-popup-shippingOptions-extra-info';
          
          extraInfo.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0003 15C10.2241 15 10.4116 14.9243 10.5626 14.7729C10.7139 14.6217 10.7895 14.4342 10.7895 14.2105V9.73684C10.7895 9.51316 10.7138 9.32561 10.5624 9.17421C10.411 9.02298 10.2234 8.94737 9.99974 8.94737C9.77588 8.94737 9.58842 9.02298 9.43737 9.17421C9.28614 9.32561 9.21053 9.51316 9.21053 9.73684V14.2105C9.21053 14.4342 9.28623 14.6217 9.43763 14.7729C9.58904 14.9243 9.77658 15 10.0003 15ZM10 7.14579C10.2409 7.14579 10.4428 7.0643 10.6058 6.90132C10.7688 6.73833 10.8503 6.5364 10.8503 6.29553C10.8503 6.05465 10.7688 5.85272 10.6058 5.68974C10.4428 5.52693 10.2409 5.44553 10 5.44553C9.75912 5.44553 9.55719 5.52693 9.39421 5.68974C9.23123 5.85272 9.14974 6.05465 9.14974 6.29553C9.14974 6.5364 9.23123 6.73833 9.39421 6.90132C9.55719 7.0643 9.75912 7.14579 10 7.14579ZM10.0018 20C8.61868 20 7.3186 19.7375 6.10158 19.2126C4.88456 18.6877 3.82596 17.9754 2.92579 17.0755C2.02561 16.1757 1.31289 15.1175 0.787631 13.9011C0.262544 12.6846 0 11.3848 0 10.0018C0 8.61868 0.262456 7.3186 0.787368 6.10158C1.31228 4.88456 2.02465 3.82596 2.92447 2.92579C3.8243 2.02561 4.88246 1.31289 6.09895 0.787631C7.31544 0.262544 8.61518 0 9.99816 0C11.3813 0 12.6814 0.262456 13.8984 0.787368C15.1154 1.31228 16.174 2.02465 17.0742 2.92447C17.9744 3.8243 18.6871 4.88246 19.2124 6.09895C19.7375 7.31544 20 8.61518 20 9.99816C20 11.3813 19.7375 12.6814 19.2126 13.8984C18.6877 15.1154 17.9754 16.174 17.0755 17.0742C16.1757 17.9744 15.1175 18.6871 13.9011 19.2124C12.6846 19.7375 11.3848 20 10.0018 20ZM10 18.4211C12.3509 18.4211 14.3421 17.6053 15.9737 15.9737C17.6053 14.3421 18.4211 12.3509 18.4211 10C18.4211 7.64912 17.6053 5.6579 15.9737 4.02632C14.3421 2.39474 12.3509 1.57895 10 1.57895C7.64912 1.57895 5.6579 2.39474 4.02632 4.02632C2.39474 5.6579 1.57895 7.64912 1.57895 10C1.57895 12.3509 2.39474 14.3421 4.02632 15.9737C5.6579 17.6053 7.64912 18.4211 10 18.4211Z" fill="currentColor" style="fill:CurrentColor;fill:color(display-p3 0.0000 0.2941 0.5294);fill-opacity:1;"/>
            </svg>
            <span>${window.webimpacto?.translates?.popup?.extra_info_fish}</span>
          `;
          
          container.appendChild(extraInfo);
        }
        
        const contentWrapper = document.createElement('div');
        contentWrapper.className = 'shipping-options-content';
        
        const grouped = this.groupWindowsByDay(windows);
        
        const maxSlotsPerDay = Math.max(
          ...Object.values(grouped).map(slots => slots.length)
        );
        
        Object.entries(grouped).forEach(([day, slots]) => {
          const dayWrapper = document.createElement('div');
          dayWrapper.className = 'shipping-day';
          
          const dayTitle = document.createElement('div');
          dayTitle.className = 'shipping-day-date';
          
          const weekdayKey = this.getWeekdayKey(day);
          const translatedDay =
          window.theme?.translates?.webimpacto?.days?.[weekdayKey] || weekdayKey;
          
          const formattedDate = this.formatDateDDMMYYYY(day);
          
          dayTitle.dataset.weekday = weekdayKey;
          dayTitle.dataset.date = day;
          
          dayTitle.textContent = translatedDay + ' ';
          const dateSpan = document.createElement('span');
          dateSpan.textContent = formattedDate;
          dayTitle.appendChild(dateSpan);
          
          dayWrapper.appendChild(dayTitle);
          
          slots.forEach(slot => {
            const slotDiv = document.createElement('div');
            
            const slotDay = slot.start.split('T')[0];
            const isTodaySlot = slotDay === localTodayStr;
            const isDisabled = isTodaySlot && isAfterCutoff;
            
            if (isDisabled) {
              slotDiv.className = 'shipping-slot shipping-slot--disabled';
            } else {
              slotDiv.className = 'shipping-slot';
            }
            
            const start = slot.start.substring(11, 16);
            const end = slot.end.substring(11, 16);
            
            slotDiv.textContent = `${start} - ${end}`;
            slotDiv.dataset.start = slot.start;
            slotDiv.dataset.end = slot.end;
            
            if (!isDisabled) {
              slotDiv.addEventListener('click', () => {
                this.handleShippingSlotClick({ start: slot.start, end: slot.end });
                
                this.querySelectorAll('.shipping-slot.selected')
                .forEach(el => el.classList.remove('selected'));
                
                slotDiv.classList.add('selected');
              });
            }
            
            dayWrapper.appendChild(slotDiv);
          });
          
          const missingSlots = maxSlotsPerDay - slots.length;
          
          for (let i = 0; i < missingSlots; i++) {
            const placeholder = document.createElement('div');
            placeholder.className = 'shipping-slot shipping-slot--placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            dayWrapper.appendChild(placeholder);
          }
          
          contentWrapper.appendChild(dayWrapper);
        });
        
        container.appendChild(contentWrapper);
      }
      
      getWeekdayKey(dateString) {
        const date = new Date(`${dateString}T00:00:00`);
        
        return date
        .toLocaleDateString('en-US', { weekday: 'long' })
        .toLowerCase();
      }
      
      formatDateDDMMYYYY(dateString) {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }
      
      async handleShippingSlotClick(slot) {
        try {
          const nowStr = FoxTheme.utils.getDate();
          localStorage.setItem('last_now', nowStr);
          const is_app = FoxTheme.utils.getAppMobile();
          const response = await fetch(FoxTheme.routes.cart_update_url, {
            ...FoxTheme.utils.fetchConfig(),
            body: JSON.stringify({
              attributes: {
                'now': nowStr,
                'is_app': is_app.toString(),
                ShippingOptionSelect: JSON.stringify(slot)
              }
            })
          });
          
          if (response.ok) {
            localStorage.setItem('_janisCommerce_deliveryWindowFrom', slot.start);
            localStorage.setItem('_janisCommerce_deliveryWindowTo', slot.end);
            this.updateExistingCartItemsWithJanis(slot.start, slot.end);
          } else {
            throw new Error();
          }
        } catch (_) {}
      }
      
      async updateExistingCartItemsWithJanis(from, to) {
        try {
          const cartRes = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
          const cart = await cartRes.json();
          if (!cart.items || cart.items.length === 0) return;
          
          let updateLineProperties = cart.items.filter(item => item.properties && (item.properties['_janisCommerce_deliveryWindowFrom'] || item.properties['_janisCommerce_deliveryWindowTo']));
          for (const [index, item] of updateLineProperties.entries()) {
            let newProps = { ...item.properties };
            if( index === 0 ) {
              newProps['_janisCommerce_deliveryWindowFrom'] = from;
              newProps['_janisCommerce_deliveryWindowTo'] = to;
            }
            else {
              delete newProps['_janisCommerce_deliveryWindowFrom'];
              delete newProps['_janisCommerce_deliveryWindowTo'];
            }
            
            await fetch(window.FoxTheme.routes.cart_change_url, {
              ...FoxTheme.utils.fetchConfig(),
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties: newProps
              })
            });
          }
          
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: await (await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' })).json() });
        } catch (e) {
          console.error("Error updating existing items with Janis props", e);
        }
      }
      
      async getSelectedShippingSlotFromCart() {
        
        return await FoxTheme.utils.updateDate().then(async () => {
          const response = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
          const cart = await response.json();
          
          if (!cart.attributes?.ShippingOptionSelect) return null;
          
          try {
            return JSON.parse(cart.attributes.ShippingOptionSelect);
          } catch (_) {
            return null;
          }
        }).catch(() => null);
      }
      async applySelectedShippingSlot() {
        const selected = await this.getSelectedShippingSlotFromCart();
        if (!selected) return;
        
        this.querySelectorAll('.shipping-slot').forEach(slotEl => {
          if (
            slotEl.dataset.start === selected.start &&
            slotEl.dataset.end === selected.end
          ) {
            slotEl.classList.add('selected');
          } else {
            slotEl.classList.remove('selected');
          }
        });
      }
    }
  );
}

async function openLocationPopupFromTrigger(prefilledCp = null) {
  const popup = document.querySelector('location-popup');
  if (!popup) return;
  
  if (!prefilledCp) {
    const headerButton = document.querySelector('.header__location-button[data-postal-code]');
    prefilledCp = headerButton?.getAttribute('data-postal-code') || await popup.getCartPostalCode();
  }
  
  if (prefilledCp) {
    const section2 = popup.querySelector('.location-popup__section.section_2');
    if (section2) {
      section2.style.display = '';
      const prevDivider = section2.previousElementSibling;
      if (prevDivider && prevDivider.classList.contains('location-popup__divider')) {
        prevDivider.style.display = '';
      }
    }
    popup.show();
    if (popup.postalCodeInput) {
      popup.postalCodeInput.value = prefilledCp;
    }
    if (popup.deliveryEnterBtn) {
      await popup.handleDeliveryEnter();
    }
  } else {
    // COMPLETE RESET when opening the selector without prefilled CP
    popup.isPickupMode = false;
    popup.lastSearchedCp = '';
    popup.lastSearchedCpValid = false;
    popup.currentPostalCode = null;
    popup.changedPostalCode = false;
    
    if (popup.postalCodeInput) {
      popup.postalCodeInput.value = '';
    }
    if (popup.storeSelect) {
      popup.storeSelect.selectedIndex = 0;
    }
    
    const section2 = popup.querySelector('.location-popup__section.section_2');
    if (section2) {
      section2.style.display = '';
      const prevDivider = section2.previousElementSibling;
      if (prevDivider && prevDivider.classList.contains('location-popup__divider')) {
        prevDivider.style.display = '';
      }
    }
    
    const section3 = popup.querySelector('.location-popup__section.section_3');
    if (section3) {
      section3.style.display = 'none';
      const prevDivider3 = section3.previousElementSibling;
      if (prevDivider3 && prevDivider3.classList.contains('location-popup__divider')) {
        prevDivider3.style.display = 'none';
      }
    }
    
    const shippingOptionsContainer = popup.querySelector('.location-popup-shippingOptions');
    if (shippingOptionsContainer) {
      shippingOptionsContainer.style.display = 'none';
      shippingOptionsContainer.innerHTML = '';
    }
    
    const errorMessage = popup.querySelector('.location-popup__section-errors');
    if (errorMessage) {
      errorMessage.classList.add('hidden');
    }
    const successMessage = popup.querySelector('.location-popup__section-success');
    if (successMessage) {
      successMessage.classList.add('hidden');
    }
    
    if (popup.mainEnterBtn) {
      popup.mainEnterBtn.disabled = true;
      popup.mainEnterBtn.classList.remove('btn--loading');
    }
    
    popup.show();
  }
}

function bindHeaderLocationPopupButtons() {
  const headerButtons = document.querySelectorAll('[data-location-popup-trigger]');
  
  headerButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      
      const zipcodeInput = button.closest('.wim-input-zipcode')?.querySelector('input');
      let cp = zipcodeInput?.value.trim() || button.getAttribute('data-postal-code') || null;
      
      const popup = document.querySelector('location-popup');
      if (popup) {
        popup.currentPostalCode = cp;
      }
      
      if (!cp && popup) {
        const headerButton = document.querySelector('.header__location-button[data-postal-code]');
        cp = headerButton?.getAttribute('data-postal-code') || await popup.getCartPostalCode();
      }
      
      if (cp) {
        button.classList.add('btn--loading');
        button.disabled = true;
      }
      
      try {
        await openLocationPopupFromTrigger(cp);
      } finally {
        button.classList.remove('btn--loading');
        button.disabled = false;
      }
    });
  });
}